export default __webpack_public_path__ + "static/media/EachOnGiveOne1.9745a019.jpg";